import type { Locale } from '@seek/melways-sites';
import { Divider, Stack } from 'braid-design-system';
import { observer } from 'mobx-react';
import { Fragment } from 'react';

import type { PageConfig } from 'src/libs/PageConfig';

import type { INote } from '../../../stores/JobApplicationStore/Note';
import type { INotes } from '../../../stores/JobApplicationStore/Notes';
import Item from '../NotesAttachments/Item';
import HtmlContent from '../PreviousApplications/Details/HtmlContent';

interface Props {
  notes: INotes;
  locale: Locale;
  addCustomError: PageConfig['dataDogRum']['addCustomError'];
}
const NoteItemList = ({ notes, locale, addCustomError }: Props) => (
  <Stack space="large">
    {notes.noteList.map((note: INote, index) => (
      <Fragment key={note.id}>
        <div data-testid="note">
          <Item
            type="note"
            user={note.createdUser}
            date={note.createdDate}
            isNew={note.isNew}
            onHide={note.markedAsNotNew}
            canDelete={note.canDelete}
            onDelete={() => notes.removeNote(`${note.id}`, addCustomError)}
            locale={locale}
          >
            <HtmlContent content={note.content} isSecondary={false} />
          </Item>
        </div>
        {index !== notes.noteList.length - 1 ? <Divider /> : null}
      </Fragment>
    ))}
  </Stack>
);

export default observer(NoteItemList);
